"use client";

import { useState } from "react";
import Image from "next/image";
import { useQuizResult } from "../hooks/use-quiz-result";
import { Back } from "@/components/ui/icons/back";
import Logo from "@workspace/ui/icons/logo";
import { RefreshIcon } from "@/components/ui/icons/refresh-icon";
import { CrossIcon } from "@/components/ui/icons/cross-icon";
import { Button } from "@workspace/ui/components/button";

const HORMONES = ["E3G", "LH", "PdG", "FSH"] as const;
const COLORS = ["#148B59", "#9246D9", "#5790FF", "#ED9512"];
const LABELS = [
  "E3G (Estrogen)",
  "LH (Luteinizing hormone)",
  "PdG (Urine metabolite of progesterone)",
  "FSH (Follicle-stimulating hormone)",
];
const HORMONE_KEYS = ["e3g", "lh", "pdg", "fsh"] as const;

export default function HormoneChartHero({onRestart, onBack, onClose}: {onRestart: () => void; onBack: () => void; onClose: () => void}) {
  const [activeId, setActiveId] = useState(0);
  const result = useQuizResult();
  

  return (
    <div className="w-full">
      <div className="flex flex-col items-center py-6 px-5 text-center w-full box-border">
        <div className="flex flex-col w-full mt-6">
        <div
          className="relative flex flex-row justify-between items-center"
        >
           <button onClick={onBack} className="cursor-pointer" aria-label="Go back">
             <Back className="size-7 aspect-square" />
           </button>
           <Logo className="h-6 absolute left-1/2 -translate-x-1/2" />
          <div className="flex flex-row gap-3 overflow-hidden">
            <Button variant="ghost" onClick={onRestart} className="p-0">
              <RefreshIcon className="size-7" />
            </Button>
            <Button variant="ghost" onClick={onClose} className="p-0">
              <CrossIcon className="size-7" />
            </Button>
          </div>
        </div>
          <h1 className="title-32 text-[#232221] text-center mt-6 mb-2">
            Your hormone chart
          </h1>
          <p className="title-16 text-[#474646] text-center mb-6">
            Based on your fertility profile, this is how your hormone chart
            might look like:
          </p>
        </div>
      </div>

      <div className="flex flex-col items-center w-full gap-6 px-5">
        <div className="flex flex-row justify-center items-center w-full">
          {HORMONES.map((h, idx) => (
            <button
              key={idx}
              className="flex-1 py-2.5 border-none rounded-[4px] mx-0.5 title-14 cursor-pointer transition-colors duration-300"
              style={{
                backgroundColor: activeId === idx ? COLORS[idx] : "#f5f5f5",
                color: activeId === idx ? "#ffffff" : COLORS[idx],
              }}
              onClick={() => setActiveId(idx)}
            >
              {h}
            </button>
          ))}
        </div>

        {result &&
          (() => {
            const key = HORMONE_KEYS[activeId];
            if (!key) return null;
            const hormone = result.hormones[key];
            return (
              <div className="flex flex-col w-full">
                <div className="w-full overflow-hidden rounded-[14px]">
                  <Image
                    src={hormone.image}
                    alt="Hormone Image"
                    width={500}
                    height={400}
                    className="w-full h-auto rounded-[14px] mb-5"
                  />
                </div>
                <h3
                  className="title-20 text-left mb-2"
                  style={{ color: COLORS[activeId] }}
                >
                  {LABELS[activeId]}
                </h3>
                <p
                  className="title-16 text-[#232221] text-left mt-1 mb-12"
                  dangerouslySetInnerHTML={{
                    __html: hormone.content.join("<br/><br/>"),
                  }}
                />
              </div>
            );
          })()}
      </div>
    </div>
  );
}
